import BaseService from '../core/service/BaseService';

const url = 'avaliacoes-metodologicas';
class AnaliseMetodologicaService extends BaseService {
    getPesquisarUrl(pagination) {
        return { url: `${url}/find-all`, pagination };
    }
    async salvar(id, dados) {
        const response = await window.$http.put(`${url}/${id}`, dados);
        return response;
    }
    async finalizar(idAvaliacao, dados) {
        return window.$http.patch(`${url}/finalizar/${idAvaliacao}`, dados);
    }
    async getRelatorio(idAnalise) {
        const response = await window.$http.get(
            `${url}/relatorios/avaliacao-metodologica/${idAnalise}`,
            {
                responseType: 'blob',
            }
        );
        return response.data;
    }
}

export default new AnaliseMetodologicaService(url, 'id', [{ field: 'proposta.id', order: 'desc' }]);
